import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { MediaClient } from '../client/media-client';
const mediaClientsMap = new Map();
export const getMediaClient = (mediaClientConfig, featureFlags) => {
  let mediaClient = mediaClientsMap.get(mediaClientConfig);

  if (!mediaClient) {
    mediaClient = new MediaClient(mediaClientConfig, featureFlags);
    mediaClientsMap.set(mediaClientConfig, mediaClient);
  }

  return mediaClient;
};

const createEmptyMediaClient = featureFlags => {
  const emptyConfig = {
    authProvider: () => Promise.resolve({
      clientId: '',
      token: '',
      baseUrl: ''
    })
  };
  return new MediaClient(emptyConfig, featureFlags);
};

export const withMediaClient = (Component, featureFlags) => {
  return class extends React.Component {
    render() {
      // TODO MPT-315: clean up after we move mediaClientConfig into FileIdentifier
      const {
        mediaClientConfig,
        ...otherProps
      } = this.props;
      const mediaClient = !mediaClientConfig ? createEmptyMediaClient(featureFlags) : getMediaClient(mediaClientConfig, featureFlags);
      return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
        mediaClient: mediaClient
      }));
    }

  };
};